module.exports = __webpack_public_path__ + "img/ir.ir95a4d32.svg";